var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.SamsungAvplay = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    if (webapis && webapis.avplay && webapis.avplay.getCurrentTime) {
      return webapis.avplay.getCurrentTime() / 1000
    }
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    if (this.plugin.getIsLive()) {
      return null
    }
    try {
      if (webapis && webapis.avplay && webapis.avplay.getDuration && webapis.avplay.getDuration()) {
        return webapis.avplay.getDuration() / 1000
      }
      return null
    } catch (e) {
      return null
    }
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    if (webapis && webapis.avplay && webapis.avplay.getCurrentStreamInfo && webapis.avplay.getCurrentStreamInfo() && webapis.avplay.getCurrentStreamInfo()[0]) {
      var j = JSON.parse(webapis.avplay.getCurrentStreamInfo()[0].extra_info)
      var bitrate = (j.Bit_rate && j.Bit_rate != "0") ? j.Bit_rate : -1;
      if (bitrate < 2.5 * 1e4) { bitrate *= 100 }//lower than 25k, for example: 22,000 -> 22,000,000 (it wont be less than 25kbps)
      else if (bitrate > 2.5 * 1e7) { bitrate /= 100 }//higher than 25M, for example: 35,000,000 -> 35,000 (it wont be more than 25Mbps)
      return bitrate
    }
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    try {
      if (webapis && webapis.avplay && webapis.avplay.getCurrentStreamInfo && webapis.avplay.getCurrentStreamInfo() && webapis.avplay.getCurrentStreamInfo()[0]) {
        var bitrate = this.getBitrate()
        var j = JSON.parse(webapis.avplay.getCurrentStreamInfo()[0].extra_info)
        if (j.Width && j.Height && bitrate) {
          return youbora.Util.buildRenditionString(j.Width, j.Height, bitrate)
        } else if (bitrate) {
          return youbora.Util.buildRenditionString(bitrate)
        }
      }
      return null
    } catch (e) {
      return null
    }
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    if (webapis && webapis.avplay && webapis.avplay.getVersion) {
      return webapis.avplay.getVersion()
    }
    return null
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return 'AVPlay'
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()
  },

  onbufferingcomplete: function () {
    //youbora.log.debug("onbufferingcomplete")
    this.fireJoin()
    this.monitor.skipNextTick()
  },
  oncurrentplaytime: function () {
    //youbora.log.debug("oncurrentplaytime")
    this.fireStart()
    if (this.getPlayhead() > 0.6) {
      this.fireJoin()
    }
  },
  onerror: function (eventType) {
    //youbora.log.debug("onerror")
    this.fireError(eventType)
    this.fireStop()
  },
  onstreamcompleted: function () {
    //youbora.log.debug("onstreamcompleted")
    this.fireStop()
  },
  playVideo: function () {
    //youbora.log.debug("playVideo")
    this.fireResume()
  },
  pauseVideo: function () {
    //youbora.log.debug("pauseVideo")
    this.firePause()
  },
  stopVideo: function () {
    //youbora.log.debug("stopVideo")
    this.fireStop()
  },
  jumpForwardVideo: function () {
    //youbora.log.debug("jumpForwardVideo")
    this.fireSeekBegin()
  },
  jumpBackwardVideo: function () {
    //youbora.log.debug("jumpBackwardVideo")
    this.fireSeekBegin()
  }
})

module.exports = youbora.adapters.SamsungAvplay
